namespace Nobox.EmailQueue {
    export interface EmailQueuePerTenantForm {
        Uid: Serenity.StringEditor;
        TenantId: Serenity.ServiceLookupEditor;
        AccountId: Serenity.ServiceLookupEditor;
        Subject: Serenity.StringEditor;
        Body: Serenity.HtmlNoteContentEditor;
        MailFrom: Serenity.StringEditor;
        MailTo: Serenity.StringEditor;
        ReplyTo: Serenity.StringEditor;
        Cc: Serenity.StringEditor;
        Bcc: Serenity.StringEditor;
        Status: Serenity.EnumEditor;
        RetryCount: Serenity.IntegerEditor;
        LockExpiration: Serenity.DateTimeEditor;
        ErrorMessage: Serenity.StringEditor;
        InsertUserId: Serenity.ServiceLookupEditor;
        SerializedMessage: Serenity.StringEditor;
        SentDate: Serenity.DateTimeEditor;
        InsertDate: Serenity.DateTimeEditor;
        Attachments: Serenity.MultipleImageUploadEditor;
        Settings: Serenity.StringEditor;
        Process: Serenity.IntegerEditor;
        IsSMTP: IsSMTPEditor;
        Host: Serenity.StringEditor;
        Port: SMTPPortEditor;
        UseSSL: Serenity.BooleanEditor;
        From: Serenity.StringEditor;
        Username: Serenity.StringEditor;
        Password: Serenity.PasswordEditor;
        Provider: ProviderEmailEditor;
        BaseUrlApi: Serenity.StringEditor;
        EndpointApi: Serenity.StringEditor;
        FromApi: Serenity.StringEditor;
        KeyApi: Serenity.StringEditor;
    }

    export class EmailQueuePerTenantForm extends Serenity.PrefixedContext {
        static formKey = 'EmailQueue.EmailQueuePerTenant';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EmailQueuePerTenantForm.init)  {
                EmailQueuePerTenantForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.ServiceLookupEditor;
                var w2 = s.HtmlNoteContentEditor;
                var w3 = s.EnumEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.DateTimeEditor;
                var w6 = s.MultipleImageUploadEditor;
                var w7 = IsSMTPEditor;
                var w8 = SMTPPortEditor;
                var w9 = s.BooleanEditor;
                var w10 = s.PasswordEditor;
                var w11 = ProviderEmailEditor;

                Q.initFormType(EmailQueuePerTenantForm, [
                    'Uid', w0,
                    'TenantId', w1,
                    'AccountId', w1,
                    'Subject', w0,
                    'Body', w2,
                    'MailFrom', w0,
                    'MailTo', w0,
                    'ReplyTo', w0,
                    'Cc', w0,
                    'Bcc', w0,
                    'Status', w3,
                    'RetryCount', w4,
                    'LockExpiration', w5,
                    'ErrorMessage', w0,
                    'InsertUserId', w1,
                    'SerializedMessage', w0,
                    'SentDate', w5,
                    'InsertDate', w5,
                    'Attachments', w6,
                    'Settings', w0,
                    'Process', w4,
                    'IsSMTP', w7,
                    'Host', w0,
                    'Port', w8,
                    'UseSSL', w9,
                    'From', w0,
                    'Username', w0,
                    'Password', w10,
                    'Provider', w11,
                    'BaseUrlApi', w0,
                    'EndpointApi', w0,
                    'FromApi', w0,
                    'KeyApi', w0
                ]);
            }
        }
    }
}
